var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.bemBlock,
      attrs: {
        id: "vuecustomizer",
        "data-get-content-asset": _vm.getContentAssetUrl
      }
    },
    [
      _c("BaseBackButton"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-detail", attrs: { "data-pid": _vm.productId } },
        [
          _c("meta", { attrs: { itemprop: "brand", content: "BIMBA Y LOLA" } }),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.bemElement(
                _vm.isBreakpointDesktop
                  ? "images-container"
                  : "carousel-container"
              )
            },
            [
              !_vm.hasImages
                ? _c("div", { class: _vm.bemElement("pre-placeholder") }, [
                    _c("span", { class: [_vm.bemElement("pic"), "img"] })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.productImageSets, function(imageSet, imageIndex) {
                return _c("BaseImage", {
                  key: imageIndex,
                  class: _vm.bemElement("pic"),
                  attrs: {
                    image: _vm.getDefaultImageFromProductImageSet(imageSet),
                    loading:
                      imageIndex < 1 || _vm.areCriticalImagesLoaded
                        ? "eager"
                        : null,
                    placeholder: _vm.getPlaceholderImageFromProductImageSet(
                      imageSet
                    ),
                    sizes: _vm.imageAttributeSizes.PDP_GALLERY,
                    srcset: _vm.getSrcsetFromProductImageSet(imageSet)
                  },
                  on: {
                    "image-click": function(event) {
                      return _vm.handleProductImageClick(event, imageIndex)
                    },
                    load: function($event) {
                      return _vm.handleImageLoad(imageIndex)
                    }
                  }
                })
              }),
              _vm._v(" "),
              _vm.$windowWidth < 575 && _vm.hasImages
                ? _c("BaseCarousel", {
                    class: _vm.bemElement("carousel"),
                    attrs: { items: _vm.productImageSets },
                    on: {
                      "carousel-click": function(event, currentIndex) {
                        return _vm.handleProductImageClick(event, currentIndex)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(slotProps) {
                            return [
                              _c("BaseImage", {
                                ref: "carouselItem" + slotProps.index,
                                class: slotProps.classname,
                                attrs: {
                                  image: _vm.getDefaultImageFromProductImageSet(
                                    slotProps.item
                                  ),
                                  "image-classes": _vm.bemElement("image"),
                                  loading:
                                    slotProps.index === 0 ||
                                    _vm.areCriticalImagesLoaded
                                      ? "eager"
                                      : null,
                                  placeholder: _vm.getPlaceholderImageFromProductImageSet(
                                    slotProps.item
                                  ),
                                  sizes: _vm.imageAttributeSizes.PDP_GALLERY,
                                  srcset: _vm.getSrcsetFromProductImageSet(
                                    slotProps.item
                                  )
                                },
                                on: {
                                  load: function($event) {
                                    return _vm.handleImageLoad(slotProps.index)
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2271512601
                    )
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { class: _vm.bemElement("text-container") }, [
            _c("div", { class: _vm.bemElement("sticky-container") }, [
              _c(
                "div",
                {
                  staticClass: "interaction--loading-content",
                  class: { "interaction-active": !_vm.loading },
                  attrs: { "data-interaction": "interaction--loading-content" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "loading-content" },
                    [_c("BaseSpinner", { attrs: { small: "", grey: "" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "loaded-content" }, [
                    _c(
                      "div",
                      { class: _vm.bemElement("sticky-child-container") },
                      [
                        _c("h1", { class: _vm.bemElement("title") }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.name) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.mainProductUnitPrice
                          ? _c("BasePrice", {
                              attrs: {
                                bem: "the-product-details-price",
                                product: _vm.mainProductUnitPrice,
                                title: _vm.$msg("price.from", "customizer")
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { class: _vm.bemElement("description") }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.product.longDescription) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.mainProductUnitPrice
                      ? _c(
                          "p",
                          { class: _vm.bemElement("unit-price") },
                          [
                            _c("BasePrice", {
                              attrs: {
                                bem: "the-product-details-unit-price",
                                product: _vm.mainProductUnitPrice,
                                title:
                                  _vm.productId && _vm.productId === "designer"
                                    ? _vm.$msg(
                                        "designer.main.unit.price",
                                        "customizer"
                                      )
                                    : _vm.$msg(
                                        "customizer.main.unit.price",
                                        "customizer"
                                      )
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.complementProductUnitPrice
                      ? _c(
                          "p",
                          { class: _vm.bemElement("unit-price") },
                          [
                            _c("BasePrice", {
                              attrs: {
                                bem: "the-product-details-unit-price",
                                product: _vm.complementProductUnitPrice,
                                title: _vm.$msg(
                                  "product.complement.unit.price",
                                  "customizer"
                                )
                              }
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$msg("product.unit", "customizer")) +
                                "\n            "
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isBreakpointMobile && !_vm.controlsVisible
                      ? _c(
                          "button",
                          {
                            class: [
                              _vm.bemElement("customize-btn", {
                                "full-width": _vm.isAppRequest
                              }),
                              "btn",
                              "btn--cta"
                            ],
                            on: { click: _vm.goToCustomizer }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$msg("button.customize", "customizer")
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isBreakpointDesktop
                      ? _c(
                          "button",
                          {
                            class: [
                              _vm.bemElement("customize-btn"),
                              "btn",
                              "btn-primary"
                            ],
                            on: { click: _vm.goToCustomizer }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$msg("button.customize", "customizer")
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "observe-visibility",
              rawName: "v-observe-visibility",
              value: _vm.handleMobileButtons,
              expression: "handleMobileButtons"
            }
          ],
          ref: "controls",
          class: _vm.bemElement("controls")
        },
        [
          _c("TheProductCustomizerVisualizer", {
            class: _vm.bemElement("visualizer")
          }),
          _vm._v(" "),
          _c("TheProductCustomizerSelector", {
            class: _vm.bemElement("selector"),
            attrs: {
              bem: "the-product-details",
              "cta-visible": _vm.controlsVisible
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.bemElement("get-inspired") },
        [
          _c("BaseTitleSubtitle", {
            class: _vm.bemElement("title-subtitle"),
            attrs: {
              title: _vm.$msg("getinspired.title", "customizer"),
              subtitle: _vm.name
            }
          }),
          _vm._v(" "),
          _c("BaseCarousel", {
            class: _vm.bemElement("slider"),
            attrs: {
              "are-controls-shown": false,
              items: _vm.imageSliderImages,
              "swiper-options": {
                allowTouchMove: true,
                breakpoints: {
                  768: {
                    slidesPerView: 3
                  },
                  1025: {
                    slidesPerView: 4,
                    spaceBetween: 4
                  }
                },
                loop: false,
                slidesPerView: 2.5,
                spaceBetween: 2
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("TheProductDetailsZoom", {
        class: {
          "is-visible": _vm.isZoomOpen
        },
        attrs: {
          "is-visible": _vm.isZoomOpen,
          images: _vm.productImageSets,
          loading: _vm.areGalleryImagesLoaded ? "eager" : null,
          "zoom-requirements": _vm.zoomRequirements
        },
        on: {
          "close-click": function($event) {
            return _vm.closeZoom(true)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }